"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemeSelector = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
require("@/components/common");
require("@/components/overlay/popover/popover");
const common_1 = require("@/components/common");
const utils_1 = require("@/utils");
const theme_1 = require("@/utils/theme");
let ThemeSelector = class ThemeSelector extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.value = 'light';
        // popover는 portal로 옮겨져 한 트리에 모이므로, 인스턴스가 여럿이어도 id가 겹치지 않게 한다.
        this.panelId = (0, utils_1.uniqueId)('theme-panel');
    }
    render() {
        return (0, lit_1.html) `
      <mm-icon-button
        variant="ghost"
        icon=${this.currentIcon}
        aria-label="테마 변경"
        aria-controls=${this.panelId}
      ></mm-icon-button>
      <mm-popover id=${this.panelId} placement="bottom-end">
        <mm-menu-item-radio-group
          name="theme"
          value=${this.value}
          aria-label="테마 선택"
          @change=${this.handleThemeChange}
        >
          ${this.renderThemeOptions()}
        </mm-menu-item-radio-group>
        <mm-separator></mm-separator>
        <mm-radius-picker></mm-radius-picker>
      </mm-popover>
    `;
    }
    renderThemeOptions() {
        return theme_1.THEMES.map(theme => (0, lit_1.html) `
        <mm-menu-item-radio
          value=${theme.value}
          icon=${theme.icon}
          label=${theme.label}
        ></mm-menu-item-radio>
      `);
    }
    connectedCallback() {
        super.connectedCallback();
        this.value = (0, theme_1.getPreferredTheme)();
    }
    get currentIcon() {
        return theme_1.THEMES.find(theme => theme.value === this.value)?.icon ?? common_1.ICON_NAMES.LIGHT_MODE;
    }
    // 선택 시 테마를 저장하고 현재 값을 동기화. popover는 portal로 옮겨져 이 shadow에서 찾을 수 없어 이벤트가 닿은 자리에서 찾는다.
    handleThemeChange(event) {
        this.value = (0, theme_1.saveTheme)(event.detail.value);
        event.currentTarget.closest('mm-popover')?.close();
    }
};
ThemeSelector.styles = (0, lit_1.css) `
    :host {
      display: inline-flex;
    }
  `;
__decorate([
    (0, decorators_js_1.property)({ type: String })
], ThemeSelector.prototype, "value", void 0);
ThemeSelector = __decorate([
    (0, decorators_js_1.customElement)('mm-theme-selector')
], ThemeSelector);
exports.ThemeSelector = ThemeSelector;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGhlbWUtc2VsZWN0b3IuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJ0aGVtZS1zZWxlY3Rvci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQSw2QkFBMkM7QUFDM0MscURBQTJEO0FBSTNELCtCQUE0QjtBQUM1QixnREFBNkM7QUFFN0MsZ0RBQStEO0FBQy9ELG1DQUFrQztBQUNsQyx5Q0FBZ0Y7QUFHekUsSUFBTSxhQUFhLEdBQW5CLE1BQU0sYUFBYyxTQUFRLGdCQUFVO0lBQXRDOztRQU11QixVQUFLLEdBQVUsT0FBTyxDQUFBO1FBQ2xELDhEQUE4RDtRQUM3QyxZQUFPLEdBQUcsSUFBQSxnQkFBUSxFQUFDLGFBQWEsQ0FBQyxDQUFBO0lBbURwRCxDQUFDO0lBakRDLE1BQU07UUFDSixPQUFPLElBQUEsVUFBSSxFQUFBOzs7ZUFHQSxJQUFJLENBQUMsV0FBVzs7d0JBRVAsSUFBSSxDQUFDLE9BQU87O3VCQUViLElBQUksQ0FBQyxPQUFPOzs7a0JBR2pCLElBQUksQ0FBQyxLQUFLOztvQkFFUixJQUFJLENBQUMsaUJBQWlCOztZQUU5QixJQUFJLENBQUMsa0JBQWtCLEVBQUU7Ozs7O0tBS2hDLENBQUE7SUFDSCxDQUFDO0lBRU8sa0JBQWtCO1FBQ3hCLE9BQU8sY0FBTSxDQUFDLEdBQUcsQ0FDZixLQUFLLENBQUMsRUFBRSxDQUFDLElBQUEsVUFBSSxFQUFBOztrQkFFRCxLQUFLLENBQUMsS0FBSztpQkFDWixLQUFLLENBQUMsSUFBSTtrQkFDVCxLQUFLLENBQUMsS0FBSzs7T0FFdEIsQ0FDRixDQUFBO0lBQ0gsQ0FBQztJQUVELGlCQUFpQjtRQUNmLEtBQUssQ0FBQyxpQkFBaUIsRUFBRSxDQUFBO1FBQ3pCLElBQUksQ0FBQyxLQUFLLEdBQUcsSUFBQSx5QkFBaUIsR0FBRSxDQUFBO0lBQ2xDLENBQUM7SUFFRCxJQUFZLFdBQVc7UUFDckIsT0FBTyxjQUFNLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxFQUFFLENBQUMsS0FBSyxDQUFDLEtBQUssS0FBSyxJQUFJLENBQUMsS0FBSyxDQUFDLEVBQUUsSUFBSSxJQUFJLG1CQUFVLENBQUMsVUFBVSxDQUFBO0lBQ3hGLENBQUM7SUFFRCxxRkFBcUY7SUFDN0UsaUJBQWlCLENBQUMsS0FBcUM7UUFDN0QsSUFBSSxDQUFDLEtBQUssR0FBRyxJQUFBLGlCQUFTLEVBQUMsS0FBSyxDQUFDLE1BQU0sQ0FBQyxLQUFjLENBQUMsQ0FDbEQ7UUFBQyxLQUFLLENBQUMsYUFBNkIsQ0FBQyxPQUFPLENBQVUsWUFBWSxDQUFDLEVBQUUsS0FBSyxFQUFFLENBQUE7SUFDL0UsQ0FBQzs7QUF6RE0sb0JBQU0sR0FBRyxJQUFBLFNBQUcsRUFBQTs7OztHQUlsQixDQUFBO0FBQzJCO0lBQTNCLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsQ0FBQzs0Q0FBdUI7QUFOdkMsYUFBYTtJQUR6QixJQUFBLDZCQUFhLEVBQUMsbUJBQW1CLENBQUM7R0FDdEIsYUFBYSxDQTJEekI7QUEzRFksc0NBQWEifQ==